import { createContext, useContext, type ReactNode } from 'react';
import type { WebBillingHost } from './types';

const WebBillingHostContext = createContext<WebBillingHost | null>(null);

/** Gives the billing screens below it the host they read and write through. */
export function WebBillingHostProvider({ host, children }: { host: WebBillingHost; children: ReactNode }) {
  return <WebBillingHostContext.Provider value={host}>{children}</WebBillingHostContext.Provider>;
}

/** The host of the nearest WebBillingHostProvider; throws when there is none. */
export function useWebBillingHost(): WebBillingHost {
  const host = useContext(WebBillingHostContext);
  if (host === null) {
    throw new Error('Hôte de facturation absent : montez WebBillingHostProvider');
  }
  return host;
}
